module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/icon_minus-2df167b77ac79da64ec098081e02913a.png";